<template>
  <BModal
    id="confirmationPublish"
    ref="confirmationPublish"
    no-close-on-esc
    no-close-on-backdrop
    hide-header-close
    hide-footer
    hide-header
    size="md"
    :centered="true"
  >
    <div class="text-center my-1">
      <img
        src="https://storage.googleapis.com/komerce/core/icon-popup-warning.png"
        alt="Komerce"
        class="m-auto"
      >
      <div class="font-semibold text-2xl text-black my-1">
        Publish Invoice
      </div>
      <p class="text-black">
        Apakah kamu yakin mau mempublish invoice ini? Pastikan data sudah benar!
      </p>
      <div class="flex justify-center">
        <BButton
          size="md"
          variant="outline-primary"
          class="mr-1"
          style="width: 160.5px"
          @click="$bvModal.hide('confirmationPublish')"
        >
          Kembali
        </BButton>
        <BButton
          size="md"
          variant="primary"
          style="width: 160.5px"
          block
          @click="$emit('publish')"
          :disabled="loadingSubmit"
        >
          Publish
        </BButton>
      </div>
    </div>
  </BModal>
</template>

<script>
export default {
  props: {
    loadingSubmit: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
